import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

const ChatSwitch = React.forwardRef<
  React.ElementRef< typeof SwitchPrimitives.Root >,
  React.ComponentPropsWithoutRef< typeof SwitchPrimitives.Root >
>( ( { className, ...props }, ref ) => (
  <SwitchPrimitives.Root
    className={ cn(
      'peer inline-flex h-5 w-10 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary-muted focus-visible:ring-offset-2 focus-visible:ring-offset-white disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-primary-muted data-[state=unchecked]:bg-slate-200 dark:focus-visible:ring-slate-300 dark:focus-visible:ring-offset-brand-primary-muted dark:data-[state=checked]:bg-slate-50 dark:data-[state=unchecked]:bg-slate-800',
      className,
    ) }
    { ...props }
    ref={ ref }>
    <SwitchPrimitives.Thumb
      className={ cn(
        'pointer-events-none block h-4 w-4 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 dark:bg-brand-primary-muted',
      ) }
    />
  </SwitchPrimitives.Root>
) );
ChatSwitch.displayName = SwitchPrimitives.Root.displayName;

export { ChatSwitch };
